/** 校验 IPv4 点分十进制地址（不含 CIDR） */
export function isValidIPv4(ipStr: string | undefined) {
  const ipv4Regex = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$/;
  return ipv4Regex.test(ipStr || '');
}

/**
 * 校验 IPv4 或 CIDR。
 * - 合法 CIDR 返回 `'CIDR'`
 * - 合法 IPv4 返回 `'IPv4'`
 * - 否则返回 `false`
 */
export function validateIP(ipStr: string | undefined) {
  if (ipStr?.includes('/')) {
    const parts = ipStr.split('/');
    if (parts.length !== 2) return false;

    const [ipPart, maskPart] = parts;
    if (!isValidIPv4(ipPart)) return false;
    if (!/^\d+$/.test(maskPart)) return false;
    const mask = parseInt(maskPart, 10);
    if (mask < 0 || mask > 32) return false;
    if (maskPart.length > 1 && maskPart.startsWith('0')) return false;

    return 'CIDR';
  }
  return isValidIPv4(ipStr) ? 'IPv4' : false;
}
